import { useEffect, useState } from "react";
import ChatWidget, { ChatMessage } from "./ChatWidget";
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { API_URL } from '../config'

const LOCAL_STORAGE_CURRENT_CHAT_KEY = 'kai-current-chat-id';

export default function AiChat() {
    const [messages, setMessages] = useState<ChatMessage[]>([]);
    const [currentChatId, setCurrentChatId] = useState(localStorage.getItem(LOCAL_STORAGE_CURRENT_CHAT_KEY));
    const [typing, setTyping] = useState(false);
    const { user } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    async function createNewChat() {
        setLoading(true);
        axios.defaults.headers.common['Authorization'] = user!!.email;
        const res = await axios.post(`${API_URL}/api/kai/v1/chat`);
        const newChatId = res.data.chatId;
        if (newChatId) {
            localStorage.setItem(LOCAL_STORAGE_CURRENT_CHAT_KEY, newChatId);
            setCurrentChatId(newChatId);
        }
        setLoading(false);
    }

    async function fetchChat() {
        const res = await axios.get(`${API_URL}/api/kai/v1/chat/${currentChatId}`);
        setMessages(res.data.messages);
    }

    useEffect(() => {
        if (!currentChatId) {
            createNewChat();
        }
    }, []);

    useEffect(() => {
        if (currentChatId) {
            setLoading(true);
            fetchChat()
                .then(() => setLoading(false));
        }
    }, [currentChatId])

    async function onSend(text: string) {
        setMessages((curMessages) => [...curMessages, { content: text, role: 'user', actions: [] }]);
        askAgent(text);
    }

    async function askAgent(text: string | null) {
        setTyping(true);
        setError('');
        try{
            const res = await axios.post(`${API_URL}/api/kai/v1/chat/${currentChatId}/messages`, { content: text });
            if (res.data) {
                setMessages((curMessages) => [...curMessages, res.data]);
            }
        } catch (err) {
            setError('Something went wrong, please try again.')
        }
        setTyping(false);
    }

    return <ChatWidget 
        loading={loading} 
        messages={messages} 
        onSend={onSend} 
        width={500} 
        typing={typing} 
        startNewChat={createNewChat}
        refetch={fetchChat}
        retry={() => askAgent(null)}
        error={error}
    />
}
